import { Button, Tooltip } from "antd";
import React from "react";

const CustomButton = props => {
  const {
    type,
    btnText,
    className,
    handleClick,
    icon,
    danger = false,
    ghost = false,
    size = "default",
    loading = false,
    shape = "",
    tooltipTitle = "",
    // antd's default is "top". Pass this where the button sits at an edge and
    // the tooltip would otherwise be clipped or cover what it describes.
    tooltipPlacement,
    disabled = false,
    form = false,
    htmlType = "",
    id = "",
    iconPosition,
    color,
    variant,
    ariaDisabled,
    // Accessible name for icon-only buttons (the tooltip alone doesn't label it).
    ariaLabel,
  } = props;
  return (
    <Tooltip title={tooltipTitle} placement={tooltipPlacement}>
      <Button
        className={className}
        type={type}
        color={color}
        variant={variant}
        onClick={handleClick}
        icon={icon}
        danger={danger}
        ghost={ghost}
        size={size}
        loading={loading}
        shape={shape}
        disabled={disabled}
        htmlType={htmlType}
        id={id}
        iconPosition={iconPosition}
        aria-disabled={ariaDisabled}
        aria-label={ariaLabel}
      >
        {btnText}
      </Button>
    </Tooltip>
  );
};

export default CustomButton;
